export const API_GET_ALL_SECUENCIALES = "/admin/secuenciales/";
export const API_PUT_UPDATE_SECUENCIAL = "/admin/secuenciales/actualizar-secuencial/";
export const API_POST_SAVE_SECUENCIAL = "/admin/secuenciales/registro-secuencial";